import styled from '../references';

export const ToolbarButton = styled.div`
  align-items: center;
  border-left: 1px solid ${props => props.theme.colors.backgroundInactive};
  color: ${props => props.theme.colors.foreground};
  cursor: pointer;
  display: flex;
  flex-grow: 1;
  justify-content: space-between;
  padding-left: 15px;
  padding-right: 15px;
  width: 100%;
`;
